import { UserPermissions } from "Infrastructure/Api/permissions";
import { PermissionGuard } from "Infrastructure/Components/PermissionGuard";
import { OrdersPage } from "Order/Pages";
import { OrderCreateManualPage } from "Order/Pages/create";
import { OrderDetailPage } from "Order/Pages/Detail";
import { OrderDetailTabs } from "Order/Pages/Detail/Tabs/Hooks/useOrderDetailTabs";
import { OrderPaths } from "Order/Routes/Routing";

export const OrderRoutes = [
	{
		path: OrderPaths.Index.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderModule.read}>
				<OrdersPage />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Create.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderModule.create}>
				<OrderCreateManualPage />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Detail.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderModule.view}>
				<OrderDetailPage currentTab={OrderDetailTabs.detail} />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Edit.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderModule.update}>
				<OrderDetailPage currentTab={OrderDetailTabs.edit} />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Payment.route,
		exact: true,
		element: (
			<PermissionGuard
				permission={[
					UserPermissions.OrderModule.update,
					UserPermissions.OrderPriceModule.view,
				]}
			>
				<OrderDetailPage currentTab={OrderDetailTabs.payment} />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Invoice.route,
		exact: true,
		element: (
			<PermissionGuard
				permission={[
					UserPermissions.OrderModule.view,
					UserPermissions.OrderInvoiceModule.view,
				]}
			>
				<OrderDetailPage currentTab={OrderDetailTabs.invoice} />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Protocol.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderModule.view}>
				<OrderDetailPage currentTab={OrderDetailTabs.protocol} />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Examination.route,
		exact: true,
		element: (
			<PermissionGuard
				permission={[UserPermissions.OrderExaminationModule.view]}
			>
				<OrderDetailPage currentTab={OrderDetailTabs.examination} />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Review.route,
		exact: true,
		element: (
			<PermissionGuard
				permission={[
					UserPermissions.OrderModule.view,
					UserPermissions.OrderPartnerReviewModule.view,
				]}
			>
				<OrderDetailPage currentTab={OrderDetailTabs.review} />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.Claim.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderClaimModule.update}>
				<OrderDetailPage currentTab={OrderDetailTabs.claim} />
			</PermissionGuard>
		),
	},
	{
		path: OrderPaths.MorningCheck.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderModule.view}>
				<OrderDetailPage currentTab={OrderDetailTabs.morningCheck} />
			</PermissionGuard>
		),
	},
];
